import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpRightChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.364 0L0 6.364h9.636V16L16 9.636V0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpRightChevron
